import styled from 'styled-components';
import { colors } from '../../../../variables/colors.js';
import { deviceWidths } from '../../../../variables/widths.js';

var MealsContainer = styled.div.withConfig({
  displayName: "hotelHitContentBodyMeals__MealsContainer",
  componentId: "sc-1v0a535-0"
})(["bottom:0;font-size:12px;padding:8px;position:absolute;right:0;text-align:right;display:flex;justify-content:space-between;@media (min-width:", "){font-size:inherit;right:auto;text-align:left;padding:16px 0 0;position:static;}"], deviceWidths.tablet);
var MealsItem = styled.div.withConfig({
  displayName: "hotelHitContentBodyMeals__MealsItem",
  componentId: "sc-1v0a535-1"
})(["display:", ";@media (min-width:", "){display:inline-block;}"], function (props) {
  return props.included ? 'inline-block' : 'none';
}, deviceWidths.tablet);
var MealsItemPackage = styled.span.withConfig({
  displayName: "hotelHitContentBodyMeals__MealsItemPackage",
  componentId: "sc-1v0a535-2"
})(["@media (min-width:", "){&::after{content:' ';}}.sg-hotel-hit__meals-icon{margin-right:4px;position:relative;width:13px;height:13px;font-size:12px;top:1px;fill:", ";@media (max-width:", "){width:10px;height:10px;}}"], deviceWidths.tablet, colors.wave, deviceWidths.tabletMax);
var MealsItemPackageExt = styled.span.withConfig({
  displayName: "hotelHitContentBodyMeals__MealsItemPackageExt",
  componentId: "sc-1v0a535-3"
})(["display:none;@media (min-width:", "){display:inline-block;}"], deviceWidths.tablet);

export { MealsContainer, MealsItem, MealsItemPackage, MealsItemPackageExt };
//# sourceMappingURL=hotelHitContentBodyMeals.js.map
